/**
 * The Icon component will be able to receive a type property.
 * This type will allow the Icon to use a different className depending on the brand.
 * This will avoid having this mapping into the CSS, which causes lot of undesired duplication
 * Bigger CSS files due to the use of extend or having to create mapping css classes.
 *
 * The exported function will receive a type and will return the class to use depending on the brand
 * Without this, all brands would use the same className, having to create new CSS classes
 */

import { v as bvVar } from 'bv';

const mappings = {
  'feature-comp-title': {
    6: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    12: 'is-alternative',
    14: 'is-inverted',
    15: 'is-inverted',
    default: 'is-main',
  },
  'inplay-sport': {
    6: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    14: 'is-inverted',
    15: 'is-inverted',
    default: 'is-main',
  },
  'inplay-slider': {
    default: 'is-inverted',
  },
  'inplay-slider-active': {
    6: 'is-active',
    7: 'is-active',
    8: 'is-active',
    10: 'is-active',
    14: 'is-active',
    15: 'is-active',
    default: 'is-main',
  },
  'upcoming-slider': {
    6: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    14: 'is-inverted',
    15: 'is-inverted',
    default: 'is-main',
  },
  'upcoming-slider-active': {
    default: 'is-active',
    12: 'is-main',
  },
  'floating-nav': {
    default: 'is-inverted',
    6: 'is-main',
    7: 'is-main',
    8: 'is-main',
    10: 'is-main',
    12: ' ',
    14: 'is-main',
    15: 'is-main',
  },
  'list-sport-icon': {
    default: 'is-main',
    6: 'is-alternative',
    8: 'is-alternative',
    10: 'is-alternative',
    12: 'is-alternative',
    14: 'is-alternative',
    15: 'is-alternative',
  },
  'user-inbox-remove': {
    default: 'is-active is-big',
    12: 'is-alternative',
  },
  'user-inbox-trash': {
    default: 'is-active',
    6: 'is-default',
    7: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    14: 'is-inverted',
    15: 'is-inverted',
  },
  'casino-on-home': {
    default: 'is-main',
    6: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    14: 'is-inverted',
    15: 'is-inverted',
  },
  'dots-icon': {
    default: 'is-main is-solid',
    6: ' ',
    8: 'is-inverted',
    10: 'is-inverted',
    12: 'is-inverted is-solid',
    14: 'is-inverted',
    15: 'is-inverted',
  },
  'header-menu-icon': {
    default: 'is-inverted',
    12: ' ',
  },
  'scoreboard-tab-icon-collapsible': {
    default: ' ',
    12: 'is-inverted is-big',
  },
  'raf-faq-arrow': {
    default: 'is-arrow-down',
    12: 'is-arrow-solid-circle-down',
  },
  'offers-nav-icon': {
    default: ' ',
    12: 'is-main',
  },
  'leaderboard-piu-events-sport-icon': {
    default: 'is-main',
    6: 'is-active',
    8: 'is-inverted',
    10: 'is-inverted',
    12: 'is-alternative',
    14: 'is-inverted',
    15: 'is-inverted',
  },
  'market-view-header-icons': {
    default: 'is-inverted',
    12: 'is-main',
  },
  'in-play-widget-icon': {
    default: 'is-main',
    6: 'is-inverted',
    8: 'is-inverted',
    10: 'is-inverted',
    12: ' ',
    14: 'is-inverted',
    15: 'is-inverted',
  },
};

export default (type) => mappings[type] && (
  mappings[type][bvVar('brandId')] || mappings[type].default
);
